/* eslint no-restricted-globals:0 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { 
  Paper
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '18px',
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: '20px',
      textAlign: 'left',
      margin: '0 auto',
      [theme.breakpoints.down('lg')]: {
        width: '90%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '70%',
      },
    },
  },
  icon: {
    verticalAlign: 'middle',
    display: 'inline',
  },
  h1: {
    marginTop: '0px',
    color: '#0e419b',
    verticalAlign: 'middle',
    display: 'inline',
  },
  [theme.breakpoints.down('lg')]: {
    pcparag: {
      display: 'none'
    },
    spparag: {
      textAlign: 'left',
      display: 'block'
    }
  },
  [theme.breakpoints.up('lg')]: {
    pcparag: {
      textAlign: 'center',
      display: 'block'
    },
    spparag: {
      display: 'none'
    }
  },



}));

const About = props => {

  const classes = useStyles();

  return (
    <div className={classes.root}>

    <Paper elevation={3}>
      <div align="center">
        <img src={`${process.env.PUBLIC_URL}/img/ico.ico`} className={classes.icon} alt="icon" />
        <h1 className={classes.h1} >CONNECTCOMPASSとは</h1>
      </div>
      <p className={classes.pcparag}>
        レセコンで受け付けたデータを使用し、グラフ・表などで薬局ごとのデータを確認することが出来ます。<br />
        メールやLINEで日次データ、月次データを配信できるので、集計データの確認が簡単です。
      </p>
      <p className={classes.spparag}>
        レセコンで受け付けたデータを使用し、グラフ・表などで薬局ごとのデータを確認することが出来ます。
        メールやLINEで日次データ、月次データを配信できるので、集計データの確認が簡単です。
      </p>
    </Paper>
  </div>
  );
}

  About.propTypes = {
    className: PropTypes.string,
  }

export default About;